export function formatCurrency(cents) {
  // Convert cents to dollars
  const dollars = cents / 100;

  // Format to USD using Intl.NumberFormat
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(dollars);
}

export function formatDate(date) {
  // Check if date is a string and parse it
  if (!date) {
    return "";
  }
  if (typeof date === "string") {
    date = new Date(date);
  }
  const formattedDate = `${(date.getMonth() + 1)
    .toString()
    .padStart(2, "0")}-${date
    .getDate()
    .toString()
    .padStart(2, "0")}-${date.getFullYear()}`;
  return formattedDate;
}
